import { render, staticRenderFns } from "./IconFavorite.vue?vue&type=template&id=b1986680&scoped=true&"
import script from "./IconFavorite.vue?vue&type=script&lang=js&"
export * from "./IconFavorite.vue?vue&type=script&lang=js&"
import style0 from "./IconFavorite.vue?vue&type=style&index=0&id=b1986680&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1986680",
  null
  
)

export default component.exports